import { render, staticRenderFns } from "./procedures-per-template-card.vue?vue&type=template&id=3b05ac62&"
import script from "./procedures-per-template-card.vue?vue&type=script&lang=js&"
export * from "./procedures-per-template-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports